import * as R from 'ramda';
import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// helpers
import * as G from '../../helpers';
// feature dashboards
import * as A from './actions';
import { getFormattedDateRangeFilters } from './helpers';
import { DAY_14, DASHBOARD_TYPE_FLEET_GENERAL } from './constants';
//////////////////////////////////////////////////

const initialState = {
  dashboardType: DASHBOARD_TYPE_FLEET_GENERAL,
  filters: {
    days: DAY_14,
    enterprise: null,
    ...getFormattedDateRangeFilters(DAY_14),
  },
  titleSortValues: {},
  tableTitleFilters: {},
  // dashboard: null,
  dashboard: {},
  normalizedCurrency: {},
};

const setValueToStore = (state, { path, value }) => (
  P.$set(path, value, state)
);

const setDashboardTypeToStore = (state, data) => (
  P.$set('dashboardType', data, state)
);

const setEnterpriseFilterToStore = (state, data) => (
  P.$set('filters.enterprise', data, state)
);

const setDateFiltersToStore = (state, { days, dateTo, dateFrom }) => (
  P.$all(
    P.$set('filters.days', days),
    P.$set('filters.dateTo', dateTo),
    P.$set('filters.dateFrom', dateFrom),
    state,
  )
);

const setTableTitleSort = (state, { sort, guid }) => {
  const titleSortValues = P.$get('titleSortValues', state);

  const values = R.propOr({}, guid, titleSortValues);

  const sortValues = G.getTableTitleSortValues(values, sort);

  return P.$set(
    'titleSortValues',
    R.assoc(guid, sortValues, titleSortValues),
    state,
  );
};

const setTableTitleFilter = (state, { filters, guid }) => {
  const tableTitleFilters = P.$get('tableTitleFilters', state);

  const filtersByGuid = R.propOr({}, guid, tableTitleFilters);
  const filterValues = G.getTableTitleFilterValues(filtersByGuid, filters);

  return P.$set(
    'tableTitleFilters',
    R.assoc(guid, filterValues, tableTitleFilters),
    state,
  );
};

const getDashboardSuccess = (state, value) => (
  P.$set('dashboard', value, state)
);

const setIndividualChartLoadingState = (state, { chartType }) => (
  P.$set(`dashboard.${chartType}.loading`, true, state)
);

const getIndividualChartSuccess = (state, data) => {
  const { chartType } = data;

  return (
    P.$all(
      P.$set(`dashboard.${chartType}`, data),
      P.$set(`dashboard.${chartType}.loading`, false),
      state,
    )
  );
};

const getNormalizedCurrencySuccess = (state, { data, enterpriseGuid }) => (
  P.$set(`normalizedCurrency.${enterpriseGuid}`, data, state)
);

export default createReducer({
  [A.setValueToStore]: setValueToStore,
  [A.setTableTitleSort]: setTableTitleSort,
  [A.getDashboardSuccess]: getDashboardSuccess,
  [A.setTableTitleFilter]: setTableTitleFilter,
  [A.setDateFiltersToStore]: setDateFiltersToStore,
  [A.setDashboardTypeToStore]: setDashboardTypeToStore,
  [A.getIndividualChartSuccess]: getIndividualChartSuccess,
  [A.setEnterpriseFilterToStore]: setEnterpriseFilterToStore,
  [A.getNormalizedCurrencySuccess]: getNormalizedCurrencySuccess,
  [A.setIndividualChartLoadingState]: setIndividualChartLoadingState,
}, initialState);
